export const nameBuilder = (firstName?: string | null, lastName?: string | null): string =>
  firstName && lastName ? `${firstName} ${lastName}` : firstName ? firstName : lastName ? lastName : 'Unknown name';
